import { styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors, linkStyles, spacing } from '#/theme/theme';

export const PageFooterVolunteeringLinksHolder = styled.div`
  margin-top: ${spacing[60]};
  padding-bottom: ${spacing[12]};
`;

export const PageFooterVolunteeringLinksTitle = styled.div`
  font-weight: normal;
  color: ${colors.mediumContentGrey};
  font-size: 18px;
  margin-top: 0;
  margin-bottom: ${spacing[24]};
`;

export const PageFooterVolunteeringLinksList = styled.div`
  display: flex;
  align-items: center;
  row-gap: ${spacing[12]};
  column-gap: ${spacing[24]};
  flex-wrap: wrap;

  /* using overflow: hidden to hide unnecessary separators on the left */
  overflow: hidden;

  > *:not(:first-child) {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -12px;
      height: 16px;
      width: 1px;
      background: currentcolor;
      pointer-events: none;
    }
  }
`;

export const PageFooterVolunteeringLinksItem = styled(ButtonOrLink)`
  ${linkStyles};

  flex-shrink: 0;
  position: relative;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.lightContentGrey};

  &:not(:hover) {
    opacity: 0.5;
  }
`;
